<template>
  <div class="gewa-wrapper">
    <div class="gewa-container">
      <img class="gewa-logo" src="/assets/gewa-logo.png" alt="gewa logo">
      <h2 class="subtitle">{{gewa.subtitle}}</h2>
      <h2 class="subtitle">{{gewa.edition}}</h2>
      <div class="description" v-html="gewa.content"></div>

      <div class="i-risultati">
        <h2>I risultati</h2>
        <div class="buttons buttons-i-risultati">
          <a
            class="button"
            href="assets/classifica-gewa-young-contest.pdf"
            target="_blank"
          >
            Classifica Gewa
            <img src="assets/download.svg" alt="download">
          </a>
          <a
            class="button"
            href="assets/classifica-generale.png"
            target="_blank"
          >
            Classifica Generale
            <img src="assets/download.svg" alt="download">
          </a>
        </div>
      </div>

      <div class="prizes">
        <div v-for="(prize, index) in gewa.prizes" :key="index" class="prize">
          <div class="prize-title">{{prize.title}}</div>
          <div class="prize-content">
            <div class="prize-location">{{prize.location}}</div>
            <div class="prize-date">{{prize.date}}</div>
            <a
              v-if="prize.link"
              class="prize-link"
              target="_blank"
              :href="'http://'+prize.link"
            >{{prize.link}}</a>
            <div v-if="prize.links" class="prize-links">
              <a
                class="prize-link"
                v-for="(link, linkIndex) in prize.links"
                :key="linkIndex"
                target="_blank"
                :href="'http://'+link"
              >{{link}}</a>
            </div>
            <a v-if="prize.email" class="prize-email" :href="'mailto:'+prize.email">{{prize.email}}</a>
          </div>
        </div>
      </div>

      <div class="content">
        <div class="text">
          <p v-for="(text, index) in gewa.footer.text" :key="index" v-html="text"></p>
        </div>
        <div class="images">
          <div class="image" v-for="(image, index) in gewa.footer.images" :key="index">
            <img :src="`assets/${image}.jpg`" :alt="`${image}-foto`">
            <img class="logo" :src="`assets/${image}-logo.png`" :alt="`${image}-logo`">
          </div>
        </div>
      </div>

      <div class="buttons">
        <a
          class="button"
          href="docs/Regolamento 2019 - Premio Liuteria Classica Jesi.pdf"
          target="_blank"
        >
          Regolamento
          <img src="assets/download.svg" alt="download">
        </a>
        <a
          class="button"
          href="docs/Domanda d'iscrizione 2019 - Premio Liuteria Classica Jesi.odt"
          target="_blank"
        >
          Modulo di iscrizione
          <img src="assets/download.svg" alt="download">
        </a>
      </div>
    </div>

    <div class="sponsors">
      <img
        v-for="(sponsor, index) in sponsors"
        :key="sponsor"
        :src="`assets/${sponsor}.jpg`"
        :alt="`${sponsor} logo`"
        :style="`height:${sponsorsHeight[index]}rem`"
      >
    </div>
  </div>
</template>

<script>
export default {
  props: ["gewa"],
  data() {
    return {
      sponsors: ["esta", "archi", "cremona", "shott", "puma", "larsen"],
      sponsorsHeight: [1.8, 1.5, 1.4, 1.3, 1.2, 1.4]
    };
  }
};
</script>

<style lang="scss" scoped>
$beige: #decbad;
$background: $beige;
$primary: #430707de;

.gewa-wrapper {
  max-width: 900px;
  margin: 0 auto;
}
.gewa-container {
  background: $beige;
  padding: 2rem;
}
.gewa-logo {
  max-width: 250px;
}
.subtitle {
  margin: 0.5rem 0;
}
.subtitle:first-of-type {
  margin-bottom: 0;
}
.subtitle:last-of-type {
  margin-top: 0;
}
.i-risultati {
  margin: 2.5rem 0;
}
.buttons.buttons-i-risultati {
  margin-top: 1rem;
}
.prizes {
  margin: 0.5rem 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.prize {
  width: 22%;
  margin-top: 1.8rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.prize-title {
  font-size: 1.1em;
  font-weight: 400;
  margin-bottom: 0.3rem;
  color: $primary;
}
.prize-date {
  font-size: 0.9em;
  font-weight: 700;
  margin-bottom: 0.1rem;
}
.prize-link,
.prize-email {
  color: #000;
  text-decoration: underline;
  display: block;
}
.content {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-top: 2rem;
}
.content .text {
  width: 35%;
  text-align: left;
}
.content .images {
  display: flex;
  justify-content: space-between;
  width: calc(65% - 2rem);
}
.content .images .image {
  width: calc(50% - 0.35rem);
}
.content .images .image img {
  border: 0.15rem solid #000;
  width: 100%;
}
.content .images .image .logo {
  border: none;
  width: auto;
  height: 1.3rem;
}
.buttons {
  display: flex;
  justify-content: center;
  margin: 2.5rem 0 0;
}
.button {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000;
  color: #fff;
  font-weight: 700;
  font-size: 0.8em;
  padding: 0.5rem 1rem;
  border-radius: 1rem;
  min-width: 250px;

  text-decoration: none;
  text-transform: uppercase;
}
.button:first-of-type {
  margin-right: 1rem;
}
.button:hover {
  background: $primary;
}
.button img {
  margin-left: 0.5rem;
}
.sponsors {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  background: #fff;
  border: solid 0.15rem $beige;
  padding: 1rem;
  padding-top: 0;
}
.sponsors img {
  height: 1.5rem;
  margin-right: 1rem;
  margin-top: 1rem;
}
.sponsors img:last-of-type {
  margin-right: 0;
}

@media (max-width: 900px) {
  .prizes {
    justify-content: center;
  }
  .prize {
    width: 40%;
  }
  .content {
    flex-direction: column;
    align-items: center;
  }
  .content .text,
  .content .images {
    width: 100%;
    max-width: 460px;
  }
  .content .text {
    margin-bottom: 1rem;
  }
}
@media (max-width: 550px) {
  .prize {
    width: 90%;
  }
  .buttons {
    flex-direction: column;
  }
  .button {
    width: 100%;
  }
  .button:first-of-type {
    margin-bottom: 1rem;
  }
}
@media (max-width: 400px) {
  .images {
    flex-direction: column;
    align-items: center;
  }
  .content .images .image {
    width: 100%;
  }
  .content .images .image:first-of-type {
    margin-bottom: 1rem;
  }
}
</style>